<div class="modal-header">
  <h2>
    {{cabecalho}}
  </h2>
</div>
<div class="modal-body">
  <label for="vistoriador">Informe um novo vistoriador :</label>
  <div>
    <select [formControl]="vistoriador" name="vistoriador" class="form-control">
      <option value="">Selecione</option>
      <option *ngFor="let o of listaVistoriador" [value]="o.id">{{o.nomeVistoriador}}</option>
    </select>
    <app-msg-erro [control]="vistoriador"></app-msg-erro>
  </div>
</div>
<div class="modal-footer d-flex justify-content-between">
  <button (click)="activeModal.close(false)" class="btn btn-secondary px-lg-5">Cancelar</button>
  <button (click)="activeModal.close(vistoriador.value)" [disabled]="vistoriador.invalid" class="btn btn-success px-5">Confirmar</button>
</div>
